import React from 'react';
import { FiStar } from 'react-icons/fi';
import Reveal from '../fx/Reveal';
import CascadeGrid from '../fx/CascadeGrid';

const testimonials = [
    {
        name: 'Ahmad Hisyam',
        role: 'Security Researcher',
        text: 'SiberLab ID helped me understand real-world attack scenarios. The hands-on labs are super useful, and I love that it is all in Bahasa Indonesia.',
    },
    {
        name: 'Alya Hanaputri',
        role: 'Web Developer',
        text: 'Their red team service revealed critical flaws in our infrastructure. Professional, efficient, and worth every cent.',
    },
    {
        name: 'Nicholas B',
        role: 'Cybersecurity Student',
        text: 'We use their training modules across departments. The gamification keeps team members deeply engaged with the material.',
    },
];

const Testimonials = () => {
    return (
        <section id="testimonials" className="relative bg-[#08090f] text-white px-6 md:px-16 py-24 overflow-hidden">
            <div className="absolute inset-0 bg-dots opacity-20 pointer-events-none" />
            <div className="relative max-w-7xl mx-auto">
                <Reveal className="text-center mb-14">
                    <span className="pill tag inline-flex mb-4">TESTIMONIALS</span>
                    <h2 className="font-display text-4xl md:text-5xl font-bold">
                        Trusted by people <span className="text-gradient-red">who break things</span>
                    </h2>
                </Reveal>

                <CascadeGrid className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" stagger={90}>
                    {testimonials.map((t, idx) => (
                        <div key={idx} className="card p-6 h-full flex flex-col">
                            <div className="flex gap-1 text-red-400 mb-4">
                                {Array.from({ length: 5 }).map((_, i) => (
                                    <FiStar key={i} fill="currentColor" />
                                ))}
                            </div>
                            <p className="text-gray-300 leading-relaxed mb-6">"{t.text}"</p>
                            <div className="mt-auto flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-500 to-red-900 text-white flex items-center justify-center font-bold font-display">
                                    {t.name[0]}
                                </div>
                                <div>
                                    <div className="font-semibold">{t.name}</div>
                                    <div className="text-xs text-gray-500 font-mono uppercase tracking-wider">{t.role}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </CascadeGrid>
            </div>
        </section>
    );
};

export default Testimonials;
